export default __webpack_public_path__ + "static/media/Balance_Sheet_Income_Statement_Template.a2585105.xlsx";